import theme from '@ifca-root/react-component/src/assets/theme'
import {
  Divider,
  Grid,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment } from 'react'
import '../Payment.scss'

export const PaymentDetailItemContent = (props: any) => {
  const { listItem } = props
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      {listItem
        ?.filter(x => x?.DocAmt !== 0)
        ?.map((el, index) => (
          <Fragment key={index}>
            <ListItemText
              primary={
                <div className="rm-padding table-wrap">
                  <Grid container className="table-content" alignItems="center">
                    <Grid item xs={4} className="fw-thin desc">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{el?.DocNo}</span>
                      </div>
                    </Grid>

                    <Grid item xs={4} className="fw-thin desc">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '100%',
                        }}
                      >
                        <span>{dateFormat(el?.DocDate)}</span>
                      </div>
                    </Grid>

                    <Grid item xs={4} className="fw-thin desc">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                          paddingRight: '8px',
                        }}
                      >
                        <span>{amtStr(el?.DocAmt)}</span>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              }
            />

            <ListItem className="table-listItem" key={index} divider>
              <Grid container>
                <ListItemText
                  primary={
                    <Grid container>
                      <Grid item xs={1} component="span">
                        <span className="desc text-noflow">{index + 1}.</span>
                      </Grid>
                      <Grid item xs={8} component="span">
                        <span className="desc text-noflow">Amount:</span>
                        <span className="p-l-3 desc text-noflow">
                          {amtStr(el?.Amount)}
                        </span>
                      </Grid>
                    </Grid>
                  }
                  secondary={
                    <>
                      <Grid container>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <span className="desc text-noflow">Tax Amount:</span>
                          <span className="p-l-3 desc text-noflow">
                            {amtStr(el?.TaxAmt)} | {el?.TaxScheme?.Name}
                          </span>
                        </Grid>
                      </Grid>

                      <Grid container>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <span className="desc text-noflow">
                            {el?.MasterCOA?.Code} | {el?.MasterCOA?.Name}
                          </span>
                        </Grid>
                      </Grid>

                      <Grid container>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <div className="desc text-noflow">
                            {el?.CostCentre?.Code}
                          </div>
                        </Grid>
                      </Grid>

                      <Grid container>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <div className="desc text-noflow">
                            {el?.Remark ?? ''}
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  }
                />
              </Grid>
            </ListItem>
            {index !== listItem.length - 1 && (
              <Divider variant="fullWidth" style={{ background: '#E4E4E4' }} />
            )}
          </Fragment>
        ))}

      <div className="footer-label" style={{ background: '#bfd3ff' }} />
    </>
  )
}
